function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAffiliatePayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2185 7.51069C21.65 7.51069 21.9997 7.16093 21.9997 6.72945V5.90915C21.9997 3.75364 20.246 2 18.0905 2C18.0905 2 5.84433 2.00184 5.81413 2.00539C4.78333 2.04141 3.79315 2.48374 3.07941 3.23162C2.34782 3.99817 1.96642 4.99518 2.00232 6.04419C2.00084 6.06407 2.00006 17.3122 2.00006 17.3122C2.00006 19.8985 4.10416 22.0026 6.69044 22.0026H18.0906C20.2461 22.0026 21.9997 20.249 21.9997 18.0935V12.162C21.9997 10.0065 20.2461 8.25286 18.0906 8.25286H5.9062C4.65189 8.25286 3.62354 7.27249 3.56507 6.02095C3.53534 5.38455 3.76428 4.77706 4.20967 4.31035C4.66149 3.83692 5.29605 3.56544 5.95057 3.56544C5.97366 3.56544 18.0905 3.56247 18.0905 3.56247C19.3844 3.56247 20.4372 4.61519 20.4372 5.90915V6.72945C20.4372 7.16093 20.787 7.51069 21.2185 7.51069ZM5.9062 9.81533H18.0905C19.3845 9.81533 20.4372 10.8681 20.4372 12.162V18.0935C20.4372 19.3874 19.3845 20.4401 18.0905 20.4401H6.69044C4.96571 20.4401 3.56253 19.037 3.56253 17.3122V9.03726C4.21596 9.52671 5.02786 9.81533 5.9062 9.81533Z",
    fill: "#F6F6F6",
    style: {
      fill: "#F6F6F6",
      fill: "color(display-p3 0.9649 0.9649 0.9649)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8748 15.1268C18.8748 15.6661 18.4375 16.1033 17.8982 16.1033C17.3589 16.1033 16.9217 15.6661 16.9217 15.1268C16.9217 14.5875 17.3589 14.1502 17.8982 14.1502C18.4375 14.1502 18.8748 14.5875 18.8748 15.1268ZM18.8748 5.90819C18.8748 5.47671 18.525 5.12695 18.0935 5.12695H5.90624C5.47476 5.12695 5.125 5.47671 5.125 5.90819C5.125 6.33967 5.47476 6.68943 5.90624 6.68943H18.0935C18.525 6.68943 18.8748 6.33967 18.8748 5.90819Z",
    fill: "#F6F6F6",
    style: {
      fill: "#F6F6F6",
      fill: "color(display-p3 0.9649 0.9649 0.9649)",
      fillOpacity: 1
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliatePayoutIcon);
export default __webpack_public_path__ + "static/media/AffiliatePayoutIcon.384626b2c8fe8662c35104cdd2b4cbd8.svg";
export { ForwardRef as ReactComponent };